// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Alert from 'react-s-alert';
import {Icon} from 'react-fa';

import TreeItemDir from './TreeItemDir.jsx';
import App from './App.jsx';

import {noop, scroll} from './utils.js';

import type {T_Next, T_Item, T_Obs} from './types.js';
import type {TreeItem} from './TreeItem.js';


/* eslint-disable no-use-before-define */

export type T_OpenNextObs = (item_obs: ?TreeItemObs) => void;

/* eslint-enable no-use-before-define */


type T_TreeItemObsProps = {
  node       : T_Item,
  indent     : number,
  parent_item: TreeItemDir,
  disabled   : boolean,
  app        : App
};


type T_TreeItemObsState = {
  show_menu : boolean,
  hilight_fm: boolean,    // highlight para señalar que se hizo click derecho sobre el item
  Loaded    : boolean
};



export default class TreeItemObs extends Component<T_TreeItemObsProps, T_TreeItemObsState> implements TreeItem {
  click : (ev: SyntheticMouseEvent<*>) => void;
  rclick: (ev: SyntheticMouseEvent<*>) => void;
  
  
  
  constructor(props: T_TreeItemObsProps) {
    super(props);
    
    this.state = {
      show_menu : false,
      hilight_fm: false,
      Loaded    : false
    };
    
    this.click  = this.click.bind(this);
    this.rclick = this.rclick.bind(this);
  }
  
  
  
  open(next: T_Next = noop): void {
    if (this.state.Loaded) {
      return next(false);
    }
    
    const {app} = this.props,
          url   = `${app.remote}/get-json/?path=${this.props.node.Path}&session_id=${app.session()}`;
    
    const preamble = (cont: T_Next) => {   // NOTE: cerrar todo antes de abrir otra nota.
      if (app.state.obs != null) {
        const item_obs = app.get_item_obs(app.state.obs.path);
        
        if (item_obs != null) {
          item_obs.close(cont);
        }
        else {
          cont(true);
        }
      }
      else {
        cont(true);
      }
    };
    
    preamble(() => {
      fetch(url).then(resp => resp.json()).then((res) => {
        if (res.error && typeof res.error === 'string') {
          Alert.error(res);
          
          next(false);
        }
        else {
          app.setState({obs: (res: T_Obs)}, () => {
            this.setState({Loaded: true}, () => next(true));
          });
        }
      });
    });
  }
  
  
  
  close(next: T_Next = noop): void {
    if (! this.state.Loaded) {
      return next(false);
    }
    
    const {app} = this.props;
    
    const end = () => {
      this.setState({Loaded: false}, () => next(true));
    };
    
    if (app.state.obs != null && app.state.obs.path === this.props.node.Path) {
      app.setState({obs: null}, end);
    }
    else {
      end();
    }
  }
  
  
  
  toggle(next: T_Next = noop): void {
    if (this.props.disabled) {
      return;
    }
    
    if (! this.state.Loaded) {
      this.open(next);
    }
    else {
      this.close(next);
    }
  }
  
  
  
  reload(next: T_Next = noop): void {    // NOTE: si no está cargado, lo abre.
    if (this.state.Loaded) {
      this.close(() => {
        this.open(next);
      });
    }
    else {
      this.open(next);
    }
  }
  
  
  
  click(ev: SyntheticMouseEvent<*>): void {
    ev.stopPropagation();
    
    if (ev.button === 0) {
      this.toggle();
    }
  }
  
  
  
  rclick(ev: SyntheticMouseEvent<*>): void {
    const {app} = this.props;
    
    if (app.can_admin_file(this.props.node)) {
      app.setState({
        tree_item_menu: {
          px  : ev.pageX,
          py  : ev.pageY,
          node: this.props.node
        }
      }, () => {
        this.setState({hilight_fm: true});
      });
    }
  }
  
  
  
  refresh(next: T_Next = noop): void {
    const {app}  = this.props,
          Loaded = app.state.obs != null && app.state.obs.path === this.props.node.Path;
    
    if (Loaded !== this.state.Loaded) {
      this.setState({Loaded}, () => next(true));
    }
    else {
      next(false);
    }
  }
  
  
  
  scroll(): void {
    scroll(ReactDOM.findDOMNode(this));
  };
  
  
  
  get_path(): string {
    return this.props.node.Path;
  }
  
  
  
  get_file(): string {
    return this.props.node.File;
  }
  
  
  
  unclick(): void {
    if (this.state.Loaded) {
      this.setState({Loaded: false});
    }
  }
  
  
  
  render() {
    const {Loaded} = this.state,
          lb_style = {fontWeight: Loaded ? 'bold' : 'normal', border: '0', paddingRight: 0, paddingLeft: 0, color: 'black'},
          indent   = {marginLeft: 15 * this.props.indent};
    
    if (this.props.node.Unpub) {
      lb_style.color = 'red';
    }
    
    if (this.state.hilight_fm) {
      lb_style.border       = '1px solid red';
      lb_style.paddingRight = 3;
      lb_style.paddingLeft  = 3;
    }
    
    return (
      <div>
        <div style={indent} className='treeItem' onClick={this.click} onContextMenu={this.rclick}>
          <Icon
            name={
              this.props.node.Unpub && ! this.props.app.agrosat_user ?
                'frown-o'
              :
                (Loaded ? 'check-square-o' : 'square-o')
            }
          />
          
          <span style={lb_style}>
            {this.props.node.label}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TreeItemObs.jsx